/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Conversations_RetryInputs */

const en_us2_coach_extra_conversations_retry = /** @type {(inputs: Coach_Extra_Conversations_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const pt_br2_coach_extra_conversations_retry = /** @type {(inputs: Coach_Extra_Conversations_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar de novo`)
};

const es_419_coach_extra_conversations_retry = /** @type {(inputs: Coach_Extra_Conversations_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar`)
};

const pt_pt2_coach_extra_conversations_retry = /** @type {(inputs: Coach_Extra_Conversations_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar outra vez`)
};

const fr_fr2_coach_extra_conversations_retry = /** @type {(inputs: Coach_Extra_Conversations_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const de_de2_coach_extra_conversations_retry = /** @type {(inputs: Coach_Extra_Conversations_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const it_it2_coach_extra_conversations_retry = /** @type {(inputs: Coach_Extra_Conversations_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Coach_Extra_Conversations_RetryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_conversations_retry = /** @type {((inputs?: Coach_Extra_Conversations_RetryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Conversations_RetryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_conversations_retry(inputs)
	if (locale === "es-419") return es_419_coach_extra_conversations_retry(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_conversations_retry(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_conversations_retry(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_conversations_retry(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_conversations_retry(inputs)
	return en_us2_coach_extra_conversations_retry(inputs)
});
export { coach_extra_conversations_retry as "coach-extra.conversations_retry" }